import {
  ExamLocationRequestForm,
  ExamLocationRequestFormProvider,
  type ExamLocationRequestFormSubmitInput,
} from '@exam-center/exam-location-management';
import {
  SearchExamLocationRequestInfosDocument,
  useCreateExamLocationRequestInfoMutation,
} from '@exam-center/graphql';
import { useNavigate, useParams } from '@exam-center/router';
import { useSnackbar } from '@shared/snackbar';

export default function CreateExamLocationRequestPage() {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { examCenterCode } = useParams('/:examCenterCode/exam-location/requests/create');

  const [createExamLocationRequest] = useCreateExamLocationRequestInfoMutation();

  const handleSubmit = async (input: ExamLocationRequestFormSubmitInput) => {
    await createExamLocationRequest({
      variables: {
        createExamLocationRequestInfoInput: {
          provinceId: input.provinceId,
          locationId: input.locationId,
          // API expects nameTh/nameEn
          nameTh: input.locationNameTh?.trim(),
          nameEn: input.locationNameEn?.trim(),
          buildingId: input.buildingId,
          buildingName: input.buildingName?.trim(),
          examCenterCode,
        },
      },
      onCompleted: (res) => {
        const createdId = res.ecCreateExamLocationRequestInfo.examLocationRequestInfo.id;
        if (createdId) {
          showSnackbar({ message: 'สร้างสถานที่สอบเรียบร้อยแล้ว', variant: 'success' });
          navigate(`/:examCenterCode/exam-location/requests/draft/:requestId`, {
            params: {
              examCenterCode,
              requestId: createdId,
            },
          });
        }
      },
      onError: () => {
        showSnackbar({ message: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', variant: 'error' });
      },
      awaitRefetchQueries: true,
      refetchQueries: [SearchExamLocationRequestInfosDocument],
    });
  };

  return (
    <ExamLocationRequestFormProvider onSubmit={handleSubmit}>
      <ExamLocationRequestForm />
    </ExamLocationRequestFormProvider>
  );
}
